import React from 'react'
import PropTypes from 'prop-types'

import '../../../assets/css/switch.css'

/**
 * Checkbox component renders a styled checkbox input with custom click and change handlers.
 *
 * @module form/InputSwitch
 * @description Checkbox component renders a styled checkbox input with custom click and change handlers.
 * @param {function} fnClick - Function to handle click events on the checkbox.
 * @param {function} fnChange - Function to handle change events on the checkbox.
 * @param {boolean} checked - Determines if the checkbox is checked or not.
 * @param {function} register - Function to register the checkbox input with react-hook-form.
 * @param {Object} field - Field configuration object containing the name and other properties.
 *
 * @example
 * const field = { name: 'acceptTerms' };
 * const register = () => {};
 * const handleClick = (checked) => console.log(checked);
 * const handleChange = (checked) => console.log(checked);
 *
 * <Checkbox
 *   fnClick={handleClick}
 *   fnChange={handleChange}
 *   checked={true}
 *   register={register}
 *   field={field}
 * />
 *
 * @returns {JSX.Element} The rendered Checkbox component.
 */

export const InputSwitch = ({ field, errors, register, isAdd, defaultData }) => {
  // const [checked, setChecked] = React.useState(isAdd ? field.defaultValue : defaultData[field.name])
  // const handleChange = (nextChecked) => {
  //   setChecked(nextChecked)
  // }

  const [switchButton, setSwitchButton] = React.useState(
    isAdd
      ? field.defaultValue
      : field.valFromObj
        ? defaultData[field.obj[0]][field.obj[1]]
        : defaultData[field.name],
  )

  const Checkbox = ({ fnClick, fnChange, checked = false, register, field }) => (
    <label className="toggle-control trtui-mb-5">
      <input
        type="checkbox"
        onClick={(e) => {
          if (fnClick !== undefined) fnClick(e.target.checked)
        }}
        onChange={(e) => {
          if (fnChange !== undefined) fnChange(e.target.checked)
        }}
        checked={checked}
        {...register(field.name)}
        data-testid="inputCheckbox"
      />
      <span className="control"></span>
    </label>
  )
  return (
    <div
      className={`trtui-col-md-${field.size}`}
      style={{ display: field.hidden ? 'none' : 'block' }}
    >
      <label className="trtui-form-label">{field.placeholder}</label>
      <br />
      <Checkbox
        title="Click"
        fnClick={() => setSwitchButton(!switchButton)}
        checked={switchButton}
        register={register}
        field={field}
        errors={errors}
      />
    </div>
  )
}

InputSwitch.propTypes = {
  field: PropTypes.object,
  register: PropTypes.object,
  isAdd: PropTypes.bool,
  defaultData: PropTypes.object,
  fnClick: PropTypes.func,
  fnChange: PropTypes.func,
  checked: PropTypes.bool,
  errors: PropTypes.object,
}
